const React = require('react');
const upperFirst = require('mn-utils/upperFirst');

const getExplorerUrlPrefixByCoin = require('../../../../../../utils/getExplorerUrlPrefixByCoin');
const {PAYMENT_METHODS} = require('../../../../../../constants/paymentMethods/');
const Tooltip = require('../../../../../dumb/Tooltip/B');
const {DisplayStatusTrx} = require('../../../../../dumb/StatusDisplay');
const {DisplayAmountFCAdmin, DisplayIdAdmin, DisplayDateTimeAdmin, DisplayDataAdmin} = require('../../../../../dumb/DisplayData');

const {AdminTableRow} = require('../../../../TableRow');

import {HelpOutlineRounded} from '@material-ui/icons/';

module.exports = ({data, index}) => {
  const {
    id,
    client_quote_id,
    app_customer_id: retailer,
    created_at,
    source_amount,
    source_asset,
    target_amount,
    target_asset,
    payment_method,
    payment_gateway,
    customer_email,
    method,
    merchant_name,
    lifeflow: status,
    account = {},
    emitter,
    reject_reason = {},
    showCustomer
  } = data;

  console.log(reject_reason);

  const paymentMethod = PAYMENT_METHODS[payment_method] || {};

  return (
    <AdminTableRow className="f12" onClick={() => emitter.emit(id)} index={index}>
      <div className="wmin185 fx1 bold">
        <DisplayIdAdmin>{id}</DisplayIdAdmin>
      </div>
      <div className="wmin185 fx1 bold">
        <DisplayIdAdmin>{client_quote_id}</DisplayIdAdmin>
      </div>
      <div className="wmin185 fx1 bold">
        <DisplayDataAdmin>{merchant_name || account.name}</DisplayDataAdmin>
        <DisplayDataAdmin className="mt3 lh16 fw4 c717275">{account.login}</DisplayDataAdmin>
      </div>
      <div className="wmin185 fx1">
        <DisplayDateTimeAdmin date={created_at} />
      </div>
      <div className="wmin185 fx1">
        <DisplayAmountFCAdmin
          fiat={{
            amount: source_amount,
            symbol: source_asset,
          }}
          crypto={{
            amount: target_amount,
            symbol: target_asset
          }}
        />
      </div>
      {showCustomer && (
        <div className="wmin185 fx1 bold">
          <DisplayDataAdmin>{customer_email}</DisplayDataAdmin>
        </div>
      )}
      <div className="wmin185 fx1 bold">
        {paymentMethod.name || method}
      </div>
      <div className="wmin185 fx1 bold">
        {payment_gateway}
      </div>
      <div className="wmin185 fx1 layoutRow jcC aiC bold">
        <DisplayStatusTrx status={status} />
        {status === 'cancelled' && (reject_reason || {}).reject_message && (
          <Tooltip
            className="ml8 mr-32 c717275"
            title={(reject_reason || {}).reject_message}
            disabledCopy
          >
            <HelpOutlineRounded className="dB-i" width="10px" />
          </Tooltip>
        )}
      </div>
    </AdminTableRow>
  );
};
